import { ILocation } from 'app/shared/model/location.model';
import { IFleet } from 'app/shared/model/fleet.model';
import { StationType } from 'app/shared/model/enumerations/station-type.model';
import { GeoPoint } from 'app/shared/model/geo-point.model';

export interface IStation {
  id?: number;
  type?: keyof typeof StationType;
  serialNumber?: string;
  model?: string;
  name?: string | null;
  position?: GeoPoint | null;
  location?: ILocation | null;
  fleet?: IFleet | null;
}

export const defaultValue: Readonly<IStation> = {};
